// regionHelpers.js

import {
  kenyaRegions,
  kenyaDistricts,
  kenyaMunicipality,
  namibiaRegions,
  namibiaMunicipality,
  SouthAfricaRegions,
  SouthAfricaMunicipality,
  SouthAfricaMunicipalitiesByRegion,
  zambiaRegions,
  zambiaMunicipality,
  BurundiRegions,
  BurundiMunicipality,
  RwandaRegions,
  RwandaMunicipality,
  UgandaRegions,
  UgandaMunicipality,
  MalawiRegions,
  MalawiMunicipality,
  AngolaRegions,
  AngolaMunicipalities,
  dropdownItems,
  BurkinaFasoRegions,
  EswatiniRegions,
  LesothoRegions,
  TanzaniaRegions,
  BurkinaFasoMunicipality,
  EswatiniMunicipality,
  LesothoMunicipalities,
  TanzaniaMunicipalities,
  CameroonRegions,
  CameroonMunicipality,
  drcRegion,
  drcMunicipality,
  ethRegion,
  ethMunicipality,
  ivorianRegion,
  ivorianMunicipality,
  BotswanaRegions,
  BotswanaMunicipality,
  LiberiaRegions,
  LiberiaMunicipalitiesByRegion,
  ZimbabweRegions,
  ZimbabweMunicipalitiesByRegion
} from './regionData';
import { ghanaRegions, ghanaMunicipality } from './regionData';
import { mozambiqueRegions, mozambiqueMunicipality } from './regionData';
import { nigeriaRegions, nigeriaMunicipality } from './regionData';
import { senegalRegions, senegalMunicipality } from './regionData';

// Helper: Get country code from dropdownItems
export const getCountryCode = (countryName) => {
  const countryMap = {
      "South Africa": "ZA",
      "Namibia": "NA",
      "Kenya": "KE",
      "Botswana": "BW",
      "Liberia": "LR",
      "Zimbabwe": "ZW",
      "Zambia": "ZM",
      "Burundi": "BI",
      "Rwanda": "RW",
      "Uganda": "UG",
      "Malawi": "MW",
      "Angola": "AO",
      "Burkina Faso": "BF",
      "Eswatini": "SZ",
      "Lesotho": "LS",
      "Tanzania": "TZ",
      "Cameroon": "CM",
      "DRC": "CD",
      "Ethiopia": "ET",
      "Côte d'Ivoire": "CI",
      "Ghana": "GH",
      "Nigeria": "NG",
      "Senegal": "SN",
      "Mozambique": "MZ"
      // Add other countries as needed
  };
  return countryMap[countryName] || "ZA"; // Default to South Africa
};

// Helper: Get region list based on country code
export function getRegionList(countryCode) {
  switch(countryCode) {
      case "254": return kenyaRegions; // Kenya
      case "264": return namibiaRegions; // Namibia
      case "27": return SouthAfricaRegions; // South Africa
      case "260": return zambiaRegions; // Zambia
      case "257": return BurundiRegions; // Burundi
      case "250": return RwandaRegions; // Rwanda
      case "256": return UgandaRegions; // Uganda
      case "265": return MalawiRegions; // Malawi
      case "244": return AngolaRegions; // Angola
      case "226": return BurkinaFasoRegions; // Burkina Faso
      case "268": return EswatiniRegions; // Eswatini
      case "266": return LesothoRegions; // Lesotho
      case "255": return TanzaniaRegions; // Tanzania
      case "237": return CameroonRegions; // Cameroon
      case "243": return drcRegion; // DRC
      case "251": return ethRegion; // Ethiopia
      case "225": return ivorianRegion; // Côte d'Ivoire
      case "233": return ghanaRegions; // Ghana
      case "234": return nigeriaRegions; // Nigeria
      case "221": return senegalRegions; // Senegal
      case "258": return mozambiqueRegions; // Mozambique
      case "267": return BotswanaRegions; // Botswana
      case "231": return LiberiaRegions; // Liberia
      case "263": return ZimbabweRegions; // Zimbabwe
      default: return dropdownItems.REGION; // fallback
  }
}

// Helper: Get district list based on country code and optional region value
export function getDistrictList(countryCode, regionValue) {
  // If no region is selected, return empty array or all municipalities based on country
  if (!regionValue) {
      switch(countryCode) {
          case "27": return []; // South Africa - requires region first
          case "264": return namibiaMunicipality; // Namibia
          case "254": return kenyaMunicipality; // Kenya
          case "260": return zambiaMunicipality; // Zambia
          case "257": return BurundiMunicipality; // Burundi
          case "250": return RwandaMunicipality; // Rwanda
          case "256": return UgandaMunicipality; // Uganda
          case "265": return MalawiMunicipality; // Malawi
          case "244": return AngolaMunicipalities; // Angola
          case "226": return BurkinaFasoMunicipality; // Burkina Faso
          case "268": return EswatiniMunicipality; // Eswatini
          case "266": return LesothoMunicipalities; // Lesotho
          case "255": return TanzaniaMunicipalities; // Tanzania
          case "237": return CameroonMunicipality; // Cameroon
          case "243": return drcMunicipality; // DRC
          case "251": return ethMunicipality; // Ethiopia
          case "225": return ivorianMunicipality; // Côte d'Ivoire
          case "233": return ghanaMunicipality; // Ghana
          case "258": return mozambiqueMunicipality; // Mozambique
          case "234": return nigeriaMunicipality; // Nigeria
          case "221": return senegalMunicipality; // Senegal
          case "267": return BotswanaMunicipality; // Botswana
          case "231": return Object.values(LiberiaMunicipalitiesByRegion).flat(); // Liberia
          case "263": return Object.values(ZimbabweMunicipalitiesByRegion).flat(); // Zimbabwe
          default: return dropdownItems.DISTRICT; // fallback
      }
  }

  // Normalize region value to string for comparison
  const regionStr = typeof regionValue === 'object' ? 
      (regionValue.value || regionValue.name || "").toString() : 
      regionValue.toString();

  switch(countryCode) {
      case "254": { // Kenya
          return kenyaMunicipality.filter(municipality => 
              municipality.regionCode === parseInt(regionStr)
          );
      }
      case "225": { // Côte d'Ivoire
        if (!regionValue) return ivorianMunicipality;
        
        // Normalize the region value to match municipality region codes
        const regionNum = typeof regionValue === 'object' ? 
            regionValue.value.toString().padStart(2, '0') : 
            regionValue.toString().padStart(2, '0');
        
        return ivorianMunicipality.filter(municipality => {
            // Ensure municipality has regionCode property
            if (!municipality.regionCode) return false;
            
            // Compare normalized region codes
            const munRegionCode = municipality.regionCode.toString().padStart(2, '0');
            return munRegionCode === regionNum;
        });
    }
      case "264": { // Namibia
          const regionNum = regionStr.padStart(2, '0');
          return namibiaMunicipality.filter(municipality => {
              const munValue = parseInt(municipality.value);
              const regionRanges = {
                  '08': [1, 7],    // Erongo
                  '12': [8, 15],    // Hardap
                  '06': [16, 21],   // Kavango East
                  '14': [22, 29],   // Kavango West
                  '11': [30, 39],   // Khomas
                  '01': [40, 44],   // Kunene
                  '04': [48, 58],   // Ohangwena
                  '10': [60, 65],   // Omaheke
                  '02': [66, 77],   // Omusati
                  '03': [78, 88],   // Oshana
                  '05': [89, 99],   // Oshikoto
                  '09': [100, 106], // Otjozondjupa
                  '07': [107, 114], // Zambezi
                  '13': [115, 121]  // Karas
              };
              const [min, max] = regionRanges[regionNum] || [0, Infinity];
              return munValue >= min && munValue <= max;
          });
      }
      case "27": { // South Africa
          const regionCode = regionStr.substring(0, 2);
          return SouthAfricaMunicipalitiesByRegion[regionCode] || [];
      }
      case "260": { // Zambia
          return zambiaMunicipality.filter(municipality => 
              municipality.regionCode === parseInt(regionStr)
          );
      }
      case "257": { // Burundi
          return BurundiMunicipality.filter(municipality => 
              municipality.region === regionStr.padStart(2, '0')
          );
      }
      case "250": { // Rwanda
          return RwandaMunicipality.filter(municipality => 
              municipality.region === regionStr.padStart(2, '0')
          );
      }
      case "256": { // Uganda
          return UgandaMunicipality.filter(municipality => {
              const munValue = parseInt(municipality.value);
              const regionRanges = {
                  '01': [1, 16],   // Northern
                  '02': [17, 46],  // Eastern
                  '03': [47, 65],  // Central
                  '04': [66, 95]   // Western
              };
              const [min, max] = regionRanges[regionStr] || [0, Infinity];
              return munValue >= min && munValue <= max;
          });
      }
      case "265": { // Malawi
          return MalawiMunicipality.filter(municipality => 
              municipality.region === regionStr.padStart(2, '0')
          );
      }
      case "268": { // Eswatini
        // Eswatini regions are mapped to districts as follows:
        const regionToDistricts = {
            '01': [1, 4],    // Hhohho
            '02': [5, 8],     // Lubombo
            '03': [9, 12],    // Manzini
            '04': [13, 16]    // Shiselweni
        };
        
        const regionNum = regionStr.padStart(2, '0');
        return EswatiniMunicipality.filter(municipality => {
            const munValue = parseInt(municipality.value);
            const [min, max] = regionToDistricts[regionNum] || [0, Infinity];
            return munValue >= min && munValue <= max;
        });
    }
    case "226": { // Burkina Faso
      if (!regionValue) return BurkinaFasoMunicipality;
      
      const regionNum = regionStr.padStart(2, '0');
      return BurkinaFasoMunicipality.filter(municipality => 
          municipality.region === regionNum
      );
  }
      case "244": { // Angola
          return AngolaMunicipalities.filter(municipality => 
              municipality.region === regionStr.padStart(2, '0')
          );
      }
      case "255": { // Tanzania
          return TanzaniaMunicipalities.filter(municipality => 
              municipality.region === regionStr.padStart(2, '0')
          );
      }
      case "243": { // DRC
          return drcMunicipality.filter(municipality => 
              municipality.regionCode === parseInt(regionStr)
          );
      }
      case "251": { // Ethiopia
          return ethMunicipality.filter(municipality => 
              municipality.regionCode === parseInt(regionStr)
          );
      }
      case "225": { // Côte d'Ivoire
          return ivorianMunicipality.filter(municipality => 
              municipality.regionCode.toString() === regionStr.padStart(2, '0')
          );
      }
      case "258": { // Mozambique
          return mozambiqueMunicipality.filter(municipality => 
              municipality.provinceCode === parseInt(regionStr)
          );
      }
      case "234": { // Nigeria
          return nigeriaMunicipality.filter(municipality => 
              municipality.zoneCode === parseInt(regionStr)
          );
      }
      case "221": { // Senegal
          return senegalMunicipality.filter(municipality => 
              municipality.regionCode.toString() === regionStr.padStart(2, '0')
          );
      }
      case "267": { // Botswana
          const regionNum = regionStr.replace(/\D/g, '');
          return BotswanaMunicipality.filter(municipality => {
              const munValue = parseInt(municipality.value.replace(/\D/g, ''));
              const regionRanges = {
                  '27': [1, 16],    // Central
                  '67': [16, 16],   // Chobe
                  '65': [17, 20],   // Ghanzi
                  '69': [21, 22],   // Kgalagadi
                  '31': [23, 25],   // Kgatleng
                  '31': [26, 33],   // Kweneng
                  '26': [34, 39],   // North-East
                  '66': [40, 44],   // North-West
                  '24': [45, 52],   // South-East
                  '62': [53, 59]    // Southern
              };
              const [min, max] = regionRanges[regionNum] || [0, Infinity];
              return munValue >= min && munValue <= max;
          });
      }
      case "231": { // Liberia
          const regionNum = regionStr.padStart(2, '0');
          return LiberiaMunicipalitiesByRegion[regionNum] || [];
      }
      case "233": { // Ghana
        if (!regionValue) return ghanaMunicipality;
      
        // Normalize region value (handles both object and string inputs)
        const selectedRegionCode = typeof regionValue === 'object' 
          ? regionValue.value 
          : regionValue.toString();
      
        return ghanaMunicipality.filter(municipality => 
          municipality.regionCode.toString() === selectedRegionCode
        );
      }
      case "237": { // Cameroon
        if (!regionValue) return CameroonMunicipality;
      
        const regionNum = typeof regionValue === 'object' 
          ? regionValue.value 
          : regionValue.toString().padStart(2, '0');
      
        // Define value ranges for each region
        const regionRanges = {
          '01': [1, 5],     // Adamawa
          '02': [6, 15],    // Centre
          '03': [16, 19],   // East
          '04': [20, 24],   // Far North
          '05': [25, 29],   // Littoral
          '06': [30, 34],   // North
          '07': [35, 39],   // Northwest
          '08': [40, 44],   // South
          '09': [45, 49],   // Southwest
          '10': [50, 54]    // West
        };
      
        const [min, max] = regionRanges[regionNum] || [0, Infinity];
        
        return CameroonMunicipality.filter(municipality => {
          const districtNum = parseInt(municipality.value);
          return districtNum >= min && districtNum <= max;
        });
      }
      case "266": { // Lesotho
        if (!regionValue) return LesothoMunicipalities;
      
        // Normalize region value (handles both object and string inputs)
        const selectedRegionCode = typeof regionValue === 'object' 
          ? regionValue.value 
          : regionValue.toString();
      
        return LesothoMunicipalities.filter(municipality => 
          municipality.region.toString() === selectedRegionCode
        );
      }
      case "263": { // Zimbabwe
          const regionNum = regionStr.padStart(2, '0');
          return ZimbabweMunicipalitiesByRegion[regionNum] || [];
      }
      default: return dropdownItems.DISTRICT; // fallback
  }
}

// Helper: Get municipality list based on country code
export function getMunicipalityList(countryCode) {
  return getDistrictList(countryCode);
}